<div class="modern-container">
  <!-- Animated Background -->
  <div class="animated-background">
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
      <div class="shape shape-5"></div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="main-title">User Assignment Portal</h1>
      <p class="main-subtitle">Streamline your workflow with intelligent user assignment</p>
    </div>

    <!-- Form Container -->
    <div class="form-container">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="modern-form">
        
      <!-- Date Range Section -->
      <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
                <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/>
                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <!-- <div class="section-info">
              <h3 class="section-title">Project Timeline</h3>
              <p class="section-description">Define the duration for this assignment</p>
            </div> -->
          </div>
          
          <div class="date-range-grid">
            <div class="date-input-group">
              <label for="startDate" class="modern-label">
                <span class="label-text">Start Date</span>
                <span class="required-indicator">*</span>
            </label>
              <div class="input-container">
              <input
                type="date"
                id="startDate"
                formControlName="startDate"
                  class="modern-input"
                [class.error]="isFieldInvalid('startDate')"
                (change)="onStartDateChange($event)"
              />
                <!-- <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </div> -->
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('startDate')">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                  <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
                </svg>
              {{ getFieldError('startDate') }}
            </div>
          </div>

          <div class="date-separator">
              <div class="separator-line"></div>
              <div class="separator-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="separator-line"></div>
          </div>

            <div class="date-input-group">
              <label for="endDate" class="modern-label">
                <span class="label-text">End Date</span>
                <span class="required-indicator">*</span>
            </label>
              <div class="input-container">
              <input
                type="date"
                id="endDate"
                formControlName="endDate"
                  class="modern-input"
                [class.error]="isFieldInvalid('endDate')"
                (change)="onEndDateChange($event)"
                [min]="userForm.get('startDate')?.value"
              />
                <!-- <div class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </div> -->
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('endDate')">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                  <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
                </svg>
              {{ getFieldError('endDate') }}
              </div>
          </div>
        </div>
      </div>

      <!-- User Selection Section -->
      <div class="form-section">
          <div class="section-header">
            <!-- <div class="section-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div> -->
            <!-- <div class="section-info">
              <h3 class="section-title">Team Member Assignment</h3>
              <p class="section-description">Select the most suitable team member for this project</p>
            </div> -->
          </div>
          
          <div class="user-selection-container">
            <label for="selectedUser" class="modern-label">
              <span class="label-text">Choose User</span>
              <span class="required-indicator">*</span>
          </label>
            <div class="select-container">
            <select
              id="selectedUser"
              formControlName="selectedUser"
                class="modern-select"
              [class.error]="isFieldInvalid('selectedUser')"
            >
                <option value="" disabled>Select a user...</option>
              <option *ngFor="let user of users" [value]="user.id">
                {{ user.name }} - {{ user.department }}
              </option>
            </select>
              <!-- <div class="select-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="6,9 12,15 18,9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div> -->
          </div>
          <div class="error-message" *ngIf="isFieldInvalid('selectedUser')">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
            {{ getFieldError('selectedUser') }}
          </div>
          
            <!-- Enhanced User Preview -->
            <div class="user-preview-card" *ngIf="userForm.get('selectedUser')?.value">
              <div class="user-avatar-large">
                <span class="avatar-text">{{ getSelectedUserInitial() }}</span>
                <div class="avatar-status"></div>
              </div>
              <div class="user-details">
                <h4 class="user-name">{{ getSelectedUserName() }}</h4>
                <p class="user-email">{{ getSelectedUserEmail() }}</p>
                <div class="user-department-badge">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="3.27,6.96 12,12.01 20.73,6.96" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ getSelectedUserDepartment() }}
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Remarks Section -->
      <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <!-- <div class="section-info">
              <h3 class="section-title">Project Details</h3>
              <p class="section-description">Provide comprehensive project information and requirements</p>
            </div> -->
          </div>
          
          <div class="textarea-container">
            <label for="remarks" class="modern-label">
              <span class="label-text">Proposal Description & Requirements</span>
              <span class="required-indicator">*</span>
          </label>
          <div class="textarea-wrapper">
            <textarea
              id="remarks"
              formControlName="remarks"
                class="modern-textarea"
              [class.error]="isFieldInvalid('remarks')"
                placeholder="Describe the project scope, objectives, deliverables, timeline expectations, and any specific requirements or constraints..."
                rows="6"
            ></textarea>
              <div class="textarea-footer">
                <div class="char-counter">
                  <span class="current-count">{{ userForm.get('remarks')?.value?.length || 0 }}</span>
                  <span class="max-count">/ 500</span>
                </div>
                <div class="textarea-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
          </div>
          <div class="error-message" *ngIf="isFieldInvalid('remarks')">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
            {{ getFieldError('remarks') }}
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <!-- <button
          type="button"
            class="action-btn secondary-btn"
          (click)="resetForm()"
          [disabled]="isLoading"
        >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <polyline points="23,4 23,10 17,10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.49 15A9 9 0 1 1 5.64 5.64L23 23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Reset Form</span>
        </button> -->
        
        <button
          type="submit"
            class="action-btn primary-btn"
          [disabled]="isLoading"
        >
          <div class="btn-content">
              <svg *ngIf="!isLoading" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="22" y1="2" x2="11" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polygon points="22,2 15,22 11,13 2,9 22,2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            <div class="loading-spinner" *ngIf="isLoading"></div>
              <span>{{ isLoading ? 'Processing Request...' : 'Submit Assignment' }}</span>
          </div>
        </button>
      </div>
    </form>
  </div>

    <!-- Enhanced Summary Card -->
    <div class="summary-card" *ngIf="userForm.get('startDate')?.value && userForm.get('endDate')?.value">
      <div class="summary-header">
        <div class="summary-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h4 class="summary-title">Assignment Summary</h4>
      </div>
      <div class="summary-content">
    <div class="summary-item">
          <div class="summary-label">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
              <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
              <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/>
              <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
            </svg>
            <span>Project Duration</span>
          </div>
          <div class="summary-value">{{ userForm.get('startDate')?.value }} → {{ userForm.get('endDate')?.value }}</div>
    </div>
    <div class="summary-item" *ngIf="userForm.get('selectedUser')?.value">
          <div class="summary-label">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Assigned To</span>
          </div>
          <div class="summary-value">{{ getSelectedUserName() }}</div>
        </div>
      </div>
    </div>
  </div>
</div>